const errorMiddleware = (store) => (next) => async (action) => {
  if (typeof action === "function") {
    try {
      return await next(action);
    } catch (error) {
      console.error("Global API Error:", error);
      store.dispatch({ type: "global/setError", payload: error.message || "Something went wrong!" });
    }
  } else {
    return next(action);
  }
};

export default errorMiddleware;
